export default { version: 'HEAD' };
